export default {
    accesos: [
        { route: 'dashboard', modulo: '' },
        { route: '', modulo: 'DashboardVentas' },
        { route: '', modulo: 'DashboardCuentas' },
        { route: '', modulo: 'DashboardCuentasRentabilidadBruta' },
        { route: '', modulo: 'DashboardCuentasConsultarPropuestas' },
        { route: '', modulo: 'DashboardAdministracion' },
        { route: '', modulo: 'DashboardProduccion' },
        { route: '', modulo: 'DashboardIndicadorVentasConsultarVentas' },
        { route: '', modulo: 'DashboardIndicadorVentasConsultarVentasExcluidas' },
        { route: '', modulo: 'DashboardIndicadorRBConsultarPresupuestos' },

        { route: 'ventas', modulo: '' },
        { route: 'ventas/presupuestosinternos', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/ABM', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/usuarios', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/produccion', modulo: '' },
        { route: 'ventas/presupuestosinternos/ordenestrabajo/:id/produccion', modulo: '' },
        { route: '', modulo: 'PresupuestosInternosAbrir' },
        { route: '', modulo: 'PresupuestosInternosDescuentoGeneral' },
        { route: '', modulo: 'PresupuestosInternosDescuentoRebate' },
        { route: '', modulo: 'PresupuestosInternosDescuentoOrdenes' },
        { route: '', modulo: 'PresupuestosInternosImagenes' },
        { route: '', modulo: 'PresupuestosInternosComisiones' },
        { route: '', modulo: 'PresupuestosInternosEditarCotizacionCertificados' },
        { route: '', modulo: 'OrdenesTrabajoEditarDescripcionCertificados' },
        { route: '', modulo: 'PresupuestosInternosAddBrief' },
        { route: '', modulo: 'PresupuestosInternosConsultarBrief' },
        { route: '', modulo: 'PresupuestosInternosFacturacionEstimada' },
        { route: '', modulo: 'PresupuestosInternosRestablecer' },
        { route: 'ventas/presupuestos-cancelados', modulo: '' },
        { route: 'ventas/subtrabajos', modulo: '' },
        { route: '', modulo: 'PresupuestosInternosProduccionMoverSubtrabajo' },
        { route: 'ventas/certificados-servicio', modulo: '' },
        { route: 'ventas/certificados-servicio/:id', modulo: '' },
        { route: 'ventas/certificados-servicio/presupuesto/:presupuestoId/add', modulo: '' },
        { route: 'ventas/certificados-servicio/:id/edit', modulo: '' },
        { route: '', modulo: 'CertificadosServicioCancelarImputacion' },
        { route: 'ventas/facturas', modulo: '' },
        { route: 'ventas/facturas/:id', modulo: '' },
        { route: 'ventas/facturas/ABM', modulo: '' },
        { route: 'ventas/facturas/ABMC', modulo: '' },
        { route: 'ventas/facturas/ABME', modulo: '' },
        { route: 'ventas/facturas/:id/credito-debito', modulo: '' },
        { route: 'ventas/facturas/:id/credito-financiacion', modulo: '' },
        { route: 'ventas/facturas/:id/credito-fee', modulo: '' },
        { route: '', modulo: 'VentasValidarAFIP' },
        { route: '', modulo: 'VentasActualizarCAE' },
        { route: '', modulo: 'VentasActualizarFechaImputacion' },

        { route: 'disenio', modulo: '' },
        { route: 'disenio/dashboard', modulo: '' },
        { route: 'disenio/briefs', modulo: '' },
        { route: 'disenio/briefs/add', modulo: '' },
        { route: 'disenio/briefs/:id/edit', modulo: '' },
        { route: 'disenio/briefs/:id/adicionales', modulo: '' },
        { route: 'disenio/briefs/:id/cambios', modulo: '' },
        { route: 'disenio/briefs/:id', modulo: '' },
        { route: '', modulo: 'BriefsCancelar' },
        { route: '', modulo: 'BriefsAgregarPresupuesto' },
        // { route: '', modulo: 'BriefsSolicitudesCambios' },
        { route: '', modulo: 'BriefsAgregarEntrega' },
        { route: '', modulo: 'BriefsEliminarEntrega' },
        { route: '', modulo: 'BriefsEntregasValidacionInformacion' },
        { route: '', modulo: 'BriefsEntregasValidacionTecnica' },
        { route: '', modulo: 'BriefsEntregasSolicitudCambios' },
        { route: '', modulo: 'BriefsEntregasSolucionarSolicitudCambios' },
        { route: '', modulo: 'BriefsAbrir' },
        { route: '', modulo: 'BriefsCerrar' },
    
        { route: 'compras', modulo: '' },
        { route: 'compras/compras', modulo: '' },
        { route: 'compras/compras/viaticos/:viaticoId/add', modulo: '' },

        { route: 'logistica', modulo: '' },
        { route: 'logistica/remitos', modulo: '' },
        { route: 'logistica/remitos/add', modulo: '' },
        { route: 'logistica/remitos/:id/duplicado', modulo: '' },
        { route: 'logistica/remitos/:id', modulo: '' },
        { route: '', modulo: 'RemitosActualizarEstado' },
        { route: '', modulo: 'RemitosAgregarEvaluacionTransporte' },
        { route: '', modulo: 'RemitosImagenesEdicion' },
        { route: 'logistica/destinos', modulo: '' },
        { route: 'logistica/destinos/:id', modulo: '' },
        { route: 'logistica/destinos/:id/ABM', modulo: '' },
        
        { route: 'clientes', modulo: '' },
        { route: 'clientes/clientes', modulo: '' },
        { route: 'clientes/clientes/:id', modulo: '' },
        { route: 'clientes/clientes/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/cuentacorriente', modulo: '' },
        { route: 'clientes/rebate', modulo: '' },
        { route: 'clientes/rebate/ABM', modulo: '' },
        { route: '', modulo: 'ClientesConfigurarRebate' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/add', modulo: '' },
        { route: 'proveedores/proveedores/:id/edit', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },
        { route: '', modulo: 'OrdenesProveedoresAgregarEvaluacion' },
        { route: '', modulo: 'OrdenesProveedoresActualizarSubtrabajo' },
        { route: '', modulo: 'OrdenesProveedoresEnviarPDF' },
        { route: 'proveedores/evaluaciones-proveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores/:id', modulo: '' },

        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/personal', modulo: '' },
        { route: 'rrhh/personal/add', modulo: '' },
        { route: 'rrhh/personal/:id/edit', modulo: '' },
        { route: 'rrhh/personal/:id', modulo: '' },
        { route: '', modulo: 'PersonalDatosNovedades' },
        { route: '', modulo: 'PersonalDatosVacaciones' },
        // { route: 'rrhh/liquidaciones-sueldos', modulo: '' },
        // { route: 'rrhh/liquidaciones-sueldos/add', modulo: '' },
        // { route: 'rrhh/liquidaciones-sueldos/:id', modulo: '' },
        // { route: 'rrhh/liquidaciones-sueldos/:id/edit', modulo: '' },
        // { route: 'rrhh/liquidaciones-sueldos/liquidacion-final/add', modulo: '' },
        // { route: 'rrhh/liquidaciones-sueldos/liquidacion-final/:id/edit', modulo: '' },
        // { route: 'rrhh/liquidaciones-sueldos/:liquidacionSueldosId/pago', modulo: '' },
        { route: 'rrhh/viaticos', modulo: '' },
        { route: 'rrhh/viaticos/add', modulo: '' },
        { route: 'rrhh/viaticos/:id', modulo: '' },
        { route: 'rrhh/viaticos/:id/edit', modulo: '' },
        { route: '', modulo: 'ViaticosSeleccionPersonal' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/bancos', modulo: '' },
        { route: 'tablas/bancos/:id', modulo: '' },
        { route: 'tablas/bancos/:id/ABM', modulo: '' },
        { route: 'tablas/paises', modulo: '' },
        { route: 'tablas/paises/:id/ABM', modulo: '' },
        { route: 'tablas/provincias', modulo: '' },
        { route: 'tablas/provincias/:id', modulo: '' },
        { route: 'tablas/provincias/:id/ABM', modulo: '' },
        { route: 'tablas/localidades', modulo: '' },
        { route: 'tablas/localidades/:id', modulo: '' },
        { route: 'tablas/localidades/:id/ABM', modulo: '' },
        { route: 'tablas/marcas', modulo: '' },
        { route: 'tablas/marcas/add', modulo: '' },
        { route: 'tablas/marcas/:id', modulo: '' },
        { route: 'tablas/marcas/:id/edit', modulo: '' },
        { route: 'tablas/rubrostrabajos', modulo: '' },
        { route: 'tablas/rubrostrabajos/:id', modulo: '' },
        { route: 'tablas/rubrostrabajos/:id/ABM', modulo: '' },
        { route: 'tablas/tareas-estados', modulo: '' },
        { route: 'tablas/tareas-estados/add', modulo: '' },
        { route: 'tablas/tareas-estados/:id', modulo: '' },
        { route: 'tablas/tareas-estados/:id/edit', modulo: '' },        
        { route: 'tablas/vendedores', modulo: '' },
        { route: 'tablas/vendedores/add', modulo: '' },
        { route: 'tablas/vendedores/:id', modulo: '' },
        { route: 'tablas/vendedores/:id/edit', modulo: '' },

        { route: 'administracion', modulo: '' },
        { route: 'administracion/bienes', modulo: '' },
        { route: 'administracion/bienes/celulares/add', modulo: '' },
        { route: 'administracion/bienes/celulares/:id/edit', modulo: '' },
        { route: 'administracion/bienes/celulares/:id', modulo: '' },
        { route: 'administracion/bienes/computadoras/add', modulo: '' },
        { route: 'administracion/bienes/computadoras/:id/edit', modulo: '' },
        { route: 'administracion/bienes/computadoras/:id', modulo: '' },
        { route: 'administracion/bienes/add', modulo: '' },
        { route: 'administracion/bienes/:id/edit', modulo: '' },
        { route: 'administracion/bienes/:id', modulo: '' },
        { route: 'administracion/indicadores', modulo: '' },
        { route: 'administracion/indicadores/gastos', modulo: '' },
        { route: 'administracion/indicadores/gastos/add', modulo: '' },
        { route: 'administracion/indicadores/gastos/:id', modulo: '' },
        { route: 'administracion/indicadores/gastos/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/gastos-ventas', modulo: '' },
        { route: 'administracion/indicadores/gastos-ventas/add', modulo: '' },
        { route: 'administracion/indicadores/gastos-ventas/:id', modulo: '' },
        { route: 'administracion/indicadores/gastos-ventas/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/compras-ventas', modulo: '' },
        { route: 'administracion/indicadores/compras-ventas/add', modulo: '' },
        { route: 'administracion/indicadores/compras-ventas/:id', modulo: '' },
        { route: 'administracion/indicadores/compras-ventas/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/plazo-anual', modulo: '' },
        { route: 'administracion/indicadores/plazo-anual/add', modulo: '' },
        { route: 'administracion/indicadores/plazo-anual/:id', modulo: '' },
        { route: 'administracion/indicadores/plazo-anual/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/plazo-semestral', modulo: '' },
        { route: 'administracion/indicadores/plazo-semestral/add', modulo: '' },
        { route: 'administracion/indicadores/plazo-semestral/:id', modulo: '' },
        { route: 'administracion/indicadores/plazo-semestral/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/plazo-clientes', modulo: '' },
        { route: 'administracion/indicadores/plazo-clientes/add', modulo: '' },
        { route: 'administracion/indicadores/plazo-clientes/:id', modulo: '' },
        { route: 'administracion/indicadores/plazo-clientes/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-anual', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-anual/add', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-anual/:id', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-anual/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-semestral', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-semestral/add', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-semestral/:id', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-semestral/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-anual', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-anual/add', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-anual/:id', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-anual/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-semestral', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-semestral/add', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-semestral/:id', modulo: '' },
        { route: 'administracion/indicadores/rentabilidad-neta-semestral/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/co4', modulo: '' },
        { route: 'administracion/indicadores/co4/add', modulo: '' },
        { route: 'administracion/indicadores/co4/:id', modulo: '' },
        { route: 'administracion/indicadores/co4/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/ventas', modulo: '' },
        { route: 'administracion/indicadores/ventas/add', modulo: '' },
        { route: 'administracion/indicadores/ventas/:id', modulo: '' },
        { route: 'administracion/indicadores/ventas/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-semestral', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-semestral/add', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-semestral/:id', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-semestral/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-anual', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-anual/add', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-anual/:id', modulo: '' },
        { route: 'administracion/indicadores/ventas-mix-anual/:id/edit', modulo: '' },
        { route: 'administracion/indicadores/ventas-trimestral', modulo: '' },
        { route: 'administracion/indicadores/ventas-trimestral/add', modulo: '' },
        { route: 'administracion/indicadores/ventas-trimestral/:id', modulo: '' },
        { route: 'administracion/indicadores/ventas-trimestral/:id/edit', modulo: '' },
        { route: 'administracion/presupuestos-gastos', modulo: '' },
        { route: 'administracion/presupuestos-gastos/add', modulo: '' },
        { route: 'administracion/presupuestos-gastos/comparativo', modulo: '' },
        { route: 'administracion/presupuestos-gastos/:id/duplicar', modulo: '' },
        { route: 'administracion/presupuestos-gastos/:id/edit', modulo: '' },
        { route: 'administracion/presupuestos-gastos/:id', modulo: '' },

        { route: 'reportes', modulo: '' },
        { route: 'reportes/ventas', modulo: '' },
        { route: 'reportes/ventas/presupuestosinternos', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-aperturas-cierres', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-premios', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-cancelados', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-cerrados', modulo: '' },
        { route: 'reportes/ventas/ventas', modulo: '' },
        { route: 'reportes/ventas/ventas-comparativo', modulo: '' },
        { route: 'reportes/ventas/ventas-resumen-clientes', modulo: '' },
        { route: 'reportes/ventas/vendedores-comisiones', modulo: '' },
        { route: 'reportes/ventas/vendedores-comisiones-resumen', modulo: '' },
        { route: 'reportes/compras', modulo: '' },
        { route: 'reportes/compras/compras-gastos', modulo: '' },
        { route: 'reportes/compras/compras-fecha', modulo: '' },
        { route: 'reportes/compras/resumen-gastos', modulo: '' },
        { route: 'reportes/compras/resumen-gastos/:id', modulo: '' },
        { route: 'reportes/compras/ordenes-remitos', modulo: '' },
        { route: 'reportes/clientes', modulo: '' },
        { route: 'reportes/clientes/deuda', modulo: '' },
        { route: 'reportes/clientes/cobros', modulo: '' },
        { route: 'reportes/clientes/plazos', modulo: '' },
        { route: 'reportes/proveedores', modulo: '' },
        { route: 'reportes/proveedores/deuda', modulo: '' },
        { route: 'reportes/proveedores/ordenes-pendientes', modulo: '' },
        { route: 'reportes/proveedores/pagos', modulo: '' },
        { route: 'reportes/proveedores/plazos', modulo: '' },
        { route: 'reportes/proveedores/ordenes-rentabilidad-negativa', modulo: '' },
        { route: 'reportes/bancos', modulo: '' },
        { route: 'reportes/bancos/ingresos-gastos', modulo: '' },
        { route: 'reportes/rrhh', modulo: '' },
        { route: 'reportes/rrhh/evolucion-sueldos', modulo: '' },
        { route: 'reportes/logistica', modulo: '' },
        { route: 'reportes/logistica/resumen-remitos', modulo: '' }
    ]
}
